import { ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';

import { Input } from '@opendoor/bricks/core';

import { TextQuestion } from 'src/lib/flow/FlowQuestion';
import { changeAnswers } from 'src/store/sellerInput';

import QuestionLabel from '../common/QuestionLabel';
import { trackAnswerChange } from './trackAnswerChange';

type SingleLineInputProps = {
  question: TextQuestion;
  value?: string;
};

const SingleLineInput: React.FC<SingleLineInputProps> = ({ question, value }) => {
  const dispatch = useDispatch();
  const { key, placeholder, disabled, label, helperText } = question;

  // TODO: allow setting this in the flow config?
  let autoComplete: 'given-name' | 'family-name' | undefined;
  if (key === 'seller.first_name') {
    autoComplete = 'given-name';
  } else if (key === 'seller.last_name') {
    autoComplete = 'family-name';
  }

  return (
    <Input
      analyticsName={`reception-fe-question-${key}`}
      placeholder={placeholder}
      disabled={disabled}
      label={<QuestionLabel title={label} tooltip={helperText} unboundedWidth />}
      id={key}
      name={key}
      onChange={(_event: ChangeEvent<HTMLInputElement>, value: string | undefined) => {
        const answer = value ?? null;
        dispatch(changeAnswers([{ key, answer }]));
      }}
      onBlur={() => trackAnswerChange(key, value)}
      value={value}
      autoComplete={autoComplete}
      //this appears to always be false?
      //unboundedWidth={unboundedWidth}

      type="text"
      delay={500}
    />
  );
};

export default SingleLineInput;
